import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties } from '~/shared/model'

export default class Region extends BaseModel {
  static override constructorName = 'Region'

  public id: number = 0
  public name: string = ''
  public slug: string = ''
  public description: string = ''
  public district: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
